import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/frontend/components/ui/tooltip";
import type { DocsHelpLinkProps } from "@/frontend/types/dashboard/settings";

/** Help-icon link to a Medblocks docs guide. Shared by the EHR detail views and the custom-credentials card. */
export function DocsHelpLink({ href, tooltip, ariaLabel, iconClassName = "size-4" }: DocsHelpLinkProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabel}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <HelpCircle className={iconClassName} />
          </a>
        </TooltipTrigger>
        <TooltipContent side="bottom" sideOffset={4} className="max-w-xs">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
